<template>
  <div class="full-text-input-tip" @click.stop="() => ''">
    <div class="full-text-input-tip-title">输入提示：</div>
    <div class="full-text-input-tip-item">
      <span>1、关键词之间用</span>
      <el-tooltip effect="dark" content="点击使用" placement="top">
        <span class="symbol-btn space-btn" @click="$emit('addSymbol', ' ')">空格</span>
      </el-tooltip>
      <span>代表“且”的搜索逻辑(如：多次 盗窃)</span>
    </div>
    <div class="full-text-input-tip-item">
      <span>2、关键词之间用</span>
      <el-tooltip effect="dark" content="点击使用" placement="top">
        <span class="symbol-btn" @click="$emit('addSymbol', '+')">+</span>
      </el-tooltip>
      <span>加号代表“且”的搜索逻辑(如：多次+扒窃)</span>
    </div>
    <div class="full-text-input-tip-item">
      <span>3、关键词之间用</span>
      <el-tooltip effect="dark" content="点击使用" placement="top">
        <span class="symbol-btn" @click="$emit('addSymbol', '|')">|</span>
      </el-tooltip>
      <span>竖线的符号表示“或”的搜索逻辑(如：入户盗窃|入室盗窃)</span>
    </div>
    <div class="full-text-input-tip-item">
      <span>4、关键词前面用</span>
      <el-tooltip effect="dark" content="点击使用" placement="top">
        <span class="symbol-btn" @click="$emit('addSymbol', '-')">-</span>
      </el-tooltip>
      <span>减号表示“不包含”的搜索逻辑(如：-累犯)</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.full-text-input-tip {
  cursor: auto;

  .blue {
    color: #2c7ddc;
  }

  .full-text-input-tip-title {
    font-size: 12px;
    color: rgba(#606266, 0.8);
    height: 30px;
    line-height: 30px;
  }

  .full-text-input-tip-item {
    font-size: 12px;
    color: #606266;
    min-height: 26px;
    line-height: 20px;
    white-space: normal;
    margin-bottom: 10px;

    .symbol-btn {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      color: #e42626;
      background-color: rgba(228, 38, 38, 0.1);
      cursor: pointer;
    }

    .space-btn {
      width: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fullTextSelect/components/inputTip.vue